<template>
    <div>
        <el-dialog :visible.sync="dialogVisible" title="修改模板" custom-class="custom-dialog" :close-on-click-modal="false"
                    @opened="dialogOpen" @closed="dialogClose" width="390px">

            <el-form ref="form" :model="form" :rules="rules" label-width="100px">

                <el-form-item  prop="name" label="模板名称">
                    <el-input v-model="form.name" maxlength="100"  style="width: 200px;"></el-input>
                </el-form-item>
                
                <el-form-item  prop="dimensionName" label="维度名称">
                    <el-select v-model="form.dimensionName" placeholder="请选择">
                        <el-option
                            v-for="item in dimensionNames"
                            :key="item.name"
                            :label="item.name"
                            :value="item.name">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item prop="defaultEvaluateIndexName" label="默认评价指标">
                    <el-input placeholder="请选择指标" :readonly="true" v-model="form.defaultEvaluateIndexName" class="input-with-select" style="width:200px;">
                        <el-button slot="append" icon="el-icon-search" @click="getEvaluate()"></el-button>
                    </el-input>
                </el-form-item>

                <el-form-item   prop="bindGradeIdstr" label="绑定年段">
                    <el-select v-model="form.bindGradeIdstr" multiple clearable  collapse-tags placeholder="请选择学校">
                        <el-option
                            v-for="item in grades"
                            :key="item.gradeId"
                            :label="item.gradeName"
                            :value="item.gradeId">
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item   prop="orderNum" label="排序号">
                    <el-input v-model="form.orderNum" maxlength="2" type="number"  style="width: 80px;"></el-input>
                </el-form-item>
            
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogClose()">取消</el-button>
                <el-button :loading="loading" type="primary" @click="save()">确定</el-button>
            </span>
        </el-dialog>
         <!-- 添加选择指标弹出框 -->
        <set-evaluate-index v-model="setEvaluateIndexVisible" :deptId="form.deptId" />
    </div>
</template>
       
<script>
    import http from '../../../../common/http';
    import setEvaluateIndex from './setEvaluateIndex.vue';

    export default {
        name: 'addTemplate',
        components: {setEvaluateIndex},
        props: {
            value: Boolean,
            template: {
                type: Object,
                default() {
                    return {}
                }
            },
        },
        data(){
            return{
                loading: false,
                dialogVisible: false,
                setEvaluateIndexVisible: false,
                form:{
                    id: "",
                    deptId: "",
                    name: "",
                    dimensionName: "",
                    defaultEvaluateIndexName: "",
                    defaultEvaluateIndexId: "",
                    bindGradeIdstr: [],
                    orderNum: ""
                },
                dimensionNames: [],
                grades: [],
                rules: {
                    name: [
                        { required: true, message: '请输入模板名称', trigger: 'blur' }
                    ],
                    dimensionName: [
                        { required: true, message: '请选择维度名称', trigger: 'blur' }
                    ],
                    orderNum: [
                        { required: true, message: '请输入排序号', trigger: 'blur' }
                    ]
                }
            }
        },
        watch: {
            value(val) {
                this.dialogVisible = val
            },
            dialogVisible(val) {
                this.$emit('input', val)
            },
        },
        created:function () {
        },
        methods:{
            dialogOpen() {
                // 初始值
                this.form.id = this.template.id
                this.form.deptId = this.template.deptId
                this.form.name = this.template.name
                this.form.dimensionName = this.template.dimensionName
                this.form.defaultEvaluateIndexName = this.template.defaultEvaluateIndexName
                this.form.defaultEvaluateIndexId = this.template.defaultEvaluateIndexId
                if(this.$util.isNotEmpty(this.template.bindGradeIdstr)){
                    this.form.bindGradeIdstr = this.template.bindGradeIdstr.split(",")
                }else{
                    this.form.bindGradeIdstr = []
                }
                this.form.orderNum = this.template.orderNum

                this.getDimensionNames()
                this.getGradeList()
            },
            dialogClose(){
                this.dialogVisible = false
            },
            // 获取维度名称列表
            getDimensionNames(){
                let url  = this.clockinDimensionListUrl;
                let data = {
                    deptId:this.form.deptId,
                    parentId:'0'
                };
                this.apiPost(url,data).then((res) => {
                    if(res.status == 200){
                       this.dimensionNames = res.data;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            // 获取年段列表
            getGradeList(){
                let url  = this.deptGradeListUrl;
                let data = {
                    deptId:this.form.deptId
                };
                this.apiPost(url,data).then((res) => {
                    if(res.status == 200){
                       this.grades = res.data;
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            getEvaluate(){
                 this.setEvaluateIndexVisible = true
            },
            setEvaluate(key,label){
                this.form.defaultEvaluateIndexId = key
                this.form.defaultEvaluateIndexName = label
            },
            save(){
                 this.$refs['form'].validate((valid) => {
                    if(valid){

                        // 绑定年段名称
                        let bindGradeNamestr= new Array()
                        if(this.form.bindGradeIdstr.length > 0){
                            for(let i=0;i<this.form.bindGradeIdstr.length;i++){
                                let gradeId = this.form.bindGradeIdstr[i]
                                let gradeName = ""
                                for(let j=0;j<this.grades.length;j++){
                                    let srcGradeId = this.grades[j].gradeId
                                    let srcGradeName = this.grades[j].gradeName
                                    if(gradeId === srcGradeId){
                                        gradeName = srcGradeName
                                        break
                                    }
                                }
                                if(this.$util.isNotEmpty(gradeName)){
                                    bindGradeNamestr.push(gradeName)
                                }
                            }
                        }

                        this.loading = true
                        let url= this.clockinTemplateUpdateUrl
                        let data = {
                            id: this.form.id,
                            name: this.form.name,
                            dimensionName: this.form.dimensionName,
                            defaultEvaluateIndexName: this.form.defaultEvaluateIndexName,
                            defaultEvaluateIndexId: this.form.defaultEvaluateIndexId,
                            bindGradeNamestr: bindGradeNamestr.join(),
                            bindGradeIdstr: this.form.bindGradeIdstr.join(),
                            orderNum: this.form.orderNum
                        };

                        // console.log(JSON.stringify(data))
                        // return

                        this.apiPost(url, data).then((res) => {
                            if(res.status == 200){
                                this.$commonFn.showTip(res.message,1)
                                this.dialogVisible=false
                                this.$parent.getData()
                            }else{
                                this.$commonFn.showTip(res.message,3)
                            }
                            this.loading = false
                        }, (err) => {
                            console.log(err)
                            this.loading = false
                        })
                    }
               });
            }
        },
        mixins: [http]
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/task/components/updateTemplate.vue